import React, { ComponentType, useEffect, useRef, useState } from 'react';
import { WorkSpaceItemListFoldeComponentConfig } from './WorkSpaceItemListFolderComponent';
import { ConstrictIcon } from '../../assets/icons/icons.tsx/ConstrictIcon';
import { NormalExpandIcon } from '../../assets/icons/icons.tsx/NormalExpandIcon';
import { WorkSpaceItemRecursive } from '../../model/ItemModel';
import { FolderIcon } from '../../assets/icons/folderIcon';
import { FolderOpenIcon } from '../../assets/icons/folderOpenIcon';

interface TreeComponentProps {
    items: WorkSpaceItemRecursive[];
    selectedFolderId: string | undefined;
    expandedLinks: Record<string, boolean>;
    toggleExpand: (id: string) => void;
    idWorkspace: string;
    setPopupError: (ok: boolean, message: string) => void;
    setPopupSuccess: (ok: boolean, message: string) => void;
    onDrop: ((event: React.DragEvent<HTMLDivElement>, key: string | undefined, endFunction: () => void) => void) | undefined;
    clickFunction: (id: string, name: string) => void;
    setSelectedFolderId: (id: string) => void;
    treeItemComponent: ComponentType<WorkSpaceItemListFoldeComponentConfig>;
}

const TreeComponent: React.FC<TreeComponentProps> = (props: TreeComponentProps) => {
    const treeRef = useRef<HTMLDivElement>(null);

    const createTree = (items: WorkSpaceItemRecursive[], countFather?: number): JSX.Element => {
        let count = countFather === undefined ? 0 : countFather + 1;
        return (
            <ul className="scroll__folder">
                {items.map(item => (
                    <li key={item.id}>
                        <div style={{
                            display: "flex",
                            whiteSpace: "nowrap",
                            paddingLeft: 18+(countFather === undefined ? 0 : countFather + 1) * 10,
                            font: props.selectedFolderId === item.id ?'normal 600 14px/21px Segoe UI':'normal 400 14px/21px Segoe UI', 
                        }}>
                            <div style={{ width: "0px", justifyContent: "center", alignItems: "center", display: "flex" }}>
                                {item.children && item.children.length > 0 ? (
                                    <button
                                        style={{ cursor: "pointer", border: "none", background: "none", width: "30px" }}
                                        onClick={() => props.toggleExpand(item.id!)}
                                    >
                                        {props.expandedLinks[item.id!] ? <FolderOpenIcon color={"#22638D"} /> : <FolderIcon color={"#22638D"} />}
                                    </button>
                                ) : (
                                    <div style={{ width: "30px" }}>
                                        <FolderIcon color={"#22638D"}/>
                                    </div>
                                )}
                            </div>

                            <props.treeItemComponent
                                idWorkspace={props.idWorkspace}
                                menuListProps={item}
                                setPopupError={props.setPopupError}
                                setPopupSucess={props.setPopupSuccess}
                                onDrop={props.onDrop}
                                clickFunction={props.clickFunction}
                                setSelectedFolderId={props.setSelectedFolderId}
                                selectedFolderId={props.selectedFolderId}
                            />
                        </div>
                        {item.children && props.expandedLinks[item.id!] && createTree(item.children, count)}
                    </li>
                ))}
            </ul>
        );
    };

    return (
        <div ref={treeRef}>
            {createTree(props.items)}
        </div>
    );
};

export default TreeComponent;
